define(["require", "exports", "tslib", "@arcgis/core/geometry/Extent", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polygon", "@arcgis/core/geometry/Polyline", "@arcgis/core/layers/FeatureLayer", "@arcgis/core/layers/GraphicsLayer", "@arcgis/core/rest/support/Query", "@arcgis/core/symbols/SimpleFillSymbol", "@arcgis/core/symbols/SimpleLineSymbol", "@arcgis/core/symbols/SimpleMarkerSymbol", "@material-ui/core/Button", "mobx", "moment", "react", "react-dom", "../components/Map", "../components/blocks", "../components/blocks/AutoCompleteField", "../model/domain", "../model/search/Search", "../model/services/EventManager", "../model/services/ServiceError", "../model/services/SrmsServiceManager", "../utils/ColourUtil", "../utils/EntityUtil", "../utils/MathUtil", "../utils/TimeUtil", "./Events", "./RouteStore"], function (require, exports, tslib_1, Extent_1, Point_1, Polygon_1, Polyline_1, FeatureLayer_1, GraphicsLayer_1, Query_1, SimpleFillSymbol_1, SimpleLineSymbol_1, SimpleMarkerSymbol_1, Button_1, mobx_1, moment_1, React, ReactDOM, Map_1, blocks_1, AutoCompleteField_1, Domains, Search_1, EventManager_1, ServiceError_1, SrmsServiceManager_1, ColourUtil_1, EntityUtil_1, MathUtil_1, TimeUtil_1, Events_1, RouteStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SearchStore = exports.SEARCH_PAGE_SIZE = void 0;
    Extent_1 = tslib_1.__importDefault(Extent_1);
    Point_1 = tslib_1.__importDefault(Point_1);
    Polygon_1 = tslib_1.__importDefault(Polygon_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    FeatureLayer_1 = tslib_1.__importDefault(FeatureLayer_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    Query_1 = tslib_1.__importDefault(Query_1);
    SimpleFillSymbol_1 = tslib_1.__importDefault(SimpleFillSymbol_1);
    SimpleLineSymbol_1 = tslib_1.__importDefault(SimpleLineSymbol_1);
    SimpleMarkerSymbol_1 = tslib_1.__importDefault(SimpleMarkerSymbol_1);
    Button_1 = tslib_1.__importDefault(Button_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    React = tslib_1.__importStar(React);
    ReactDOM = tslib_1.__importStar(ReactDOM);
    Domains = tslib_1.__importStar(Domains);
    exports.SEARCH_PAGE_SIZE = 50;
    class SearchStore {
        constructor(storeManager) {
            Object.defineProperty(this, "results", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "resultCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isSearching", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "enableSearchMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: true
            });
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "map", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "lastHighlighted", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "txId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "txPromiseCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {}
            });
            Object.defineProperty(this, "SEARCH_PRECISION_DIFF", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0.003
            });
            Object.defineProperty(this, "defaultPolylineSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleLineSymbol_1.default({
                    style: "solid",
                    color: ColourUtil_1.ColourUtil.PrimaryActive,
                    width: 1.5
                })
            });
            Object.defineProperty(this, "defaultPolygonSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleFillSymbol_1.default({
                    style: "solid",
                    outline: this.defaultPolylineSymbol,
                    color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.PrimaryActive, 0.4)
                })
            });
            Object.defineProperty(this, "defaultPointSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleMarkerSymbol_1.default({
                    style: "circle",
                    size: 20,
                    outline: this.defaultPolylineSymbol,
                    color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.PrimaryActive, 0.4)
                })
            });
            Object.defineProperty(this, "activePolylineSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleLineSymbol_1.default({
                    style: "solid",
                    color: ColourUtil_1.ColourUtil.White,
                    width: 1.5
                })
            });
            Object.defineProperty(this, "activePolygonSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleFillSymbol_1.default({
                    style: "solid",
                    outline: this.activePolylineSymbol,
                    color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.Secondary, 0.8)
                })
            });
            Object.defineProperty(this, "activePointSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new SimpleMarkerSymbol_1.default({
                    style: "circle",
                    size: 20,
                    outline: this.activePolylineSymbol,
                    color: ColourUtil_1.ColourUtil.make(ColourUtil_1.ColourUtil.Secondary, 0.8)
                })
            });
            Object.defineProperty(this, "onResultSelected", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (g, zoomTo = true) => {
                    if (g) {
                        this.onResultHighlighted(g);
                        if (zoomTo) {
                            (0, Map_1.goTo)(this.map, g.geometry, 7);
                        }
                    }
                }
            });
            Object.defineProperty(this, "getPopupBody", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (g) => {
                    const fields = g.searchLayer.fields
                        .filter(x => x.visible)
                        .map(x => {
                        let label = x.alias;
                        let value = (0, EntityUtil_1.getGraphicAttribute)(g, x.name);
                        const domainIndex = label.indexOf("::");
                        if (domainIndex > -1) {
                            const domainClassName = x.alias.substring(domainIndex + 2);
                            const domainClass = Domains[domainClassName];
                            const kv = domainClass.findByKey(value);
                            if (kv && kv.value) {
                                value = kv.value;
                            }
                            label = x.alias.substr(0, domainIndex);
                            return React.createElement("div", { style: { paddingBottom: "4px" } },
                                label,
                                ":\u00A0",
                                value);
                        }
                        else if (x instanceof Search_1.ImageSearchField) {
                            const params = [];
                            params.push(`${x.imageIdParam}=${(0, EntityUtil_1.getGraphicAttribute)(g, x.idField)}`);
                            const url = SrmsServiceManager_1.SrmsServiceManager.Instance[x.service].buildGetUrl(x.method, params.join("&"));
                            return React.createElement("a", { href: url, target: "_blank" },
                                React.createElement("img", { className: "popup-img", src: url }));
                        }
                        else {
                            if (value && x.dateFormat) {
                                value = (0, moment_1.default)(value).format(x.dateFormat);
                            }
                            return React.createElement("div", { style: { paddingBottom: "4px" } },
                                label,
                                ": ",
                                value);
                        }
                    });
                    fields.unshift(React.createElement("div", { style: { paddingBottom: "4px" } },
                        "Type: ",
                        g.searchLayer.name));
                    let node = document.createElement("div");
                    const open = () => {
                        this.reset();
                        (0, RouteStore_1.openRoute)({ pathname: g.route });
                    };
                    ReactDOM.render(React.createElement(blocks_1.VGroup, null,
                        fields,
                        g.route
                            ? React.createElement("div", null,
                                React.createElement(Button_1.default, { variant: "outlined", onClick: open }, "Open"))
                            : null), node);
                    return node;
                }
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            this.results = new GraphicsLayer_1.default({ id: "searchResultGraphics" });
            this.resultCount = 0;
            EventManager_1.EventManager.Instance.on(Events_1.MAP_READY_EVENT, (map) => {
                this.map = map;
                this.map.map.layers.add(this.results);
                EventManager_1.EventManager.Instance.on("entity.*.success", (entityId) => {
                    this.reset();
                });
                EventManager_1.EventManager.Instance.on(Events_1.ROUTE_ENTER_EVENT, (path) => {
                    if (!/\/create/g.test(path)) {
                        this.reset();
                    }
                });
            });
        }
        reset() {
            this.results.removeAll();
            this.resultCount = 0;
            this.map.popup.close();
            this.isSearching = false;
            this.enableSearchMore = true;
        }
        get HasMoreSearchPages() {
            console.log("search again?", this.resultCount % exports.SEARCH_PAGE_SIZE, this.resultCount % exports.SEARCH_PAGE_SIZE === 0);
            return (this.enableSearchMore &&
                this.resultCount >= exports.SEARCH_PAGE_SIZE &&
                this.resultCount % exports.SEARCH_PAGE_SIZE === 0);
        }
        addResult(results, zoomTo = false) {
            if (results.length > 0) {
                results.forEach(g => {
                    this.applySymbol(g);
                    g.attributes["class"] = "graphic";
                    this.results.add(g);
                });
                this.results.graphics.sort((a, b) => {
                    const aRank = a.searchLayer.rank;
                    const bRank = b.searchLayer.rank;
                    if (aRank === bRank) {
                        return 0;
                    }
                    if (aRank > bRank) {
                        return 1;
                    }
                    return -1;
                });
                if (zoomTo) {
                    (0, Map_1.goTo)(this.map, this.results.graphics.toArray());
                }
            }
            this.resultCount = this.results.graphics.length;
        }
        searchByAttribute(searchLayer, offset = 0, limit = exports.SEARCH_PAGE_SIZE) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!searchLayer || !searchLayer.IsValid) {
                    return;
                }
                if (!this.enableSearchMore) {
                    return;
                }
                this.txId = (0, MathUtil_1.random)();
                if (offset === 0) {
                    this.reset();
                }
                yield (0, TimeUtil_1.wait)(AutoCompleteField_1.AutoCompleteDebounceRate + 1);
                const q = new Query_1.default();
                q.start = offset;
                q.num = limit;
                q.outSpatialReference = this.map.spatialReference;
                q.where = searchLayer.toExpressionQuery();
                q.returnGeometry = true;
                if (!q.where || q.where.trim().length === 0) {
                    q.where = "1=1";
                }
                console.log("searching", q.where);
                EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_INIT, "search");
                this.isSearching = true;
                (0, EventManager_1.notify)("Searching...");
                this._search(this.txId, searchLayer, q)
                    .then(({ txId, results }) => {
                    if (this.txId === txId) {
                        if (results.length === 0) {
                            this.enableSearchMore = false;
                        }
                        this.addResult(results, true);
                        (0, EventManager_1.notify)(`${results.length} results found`);
                        EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_SUCCESS, "search");
                        this.isSearching = false;
                        delete this.txPromiseCount[txId];
                    }
                    else {
                        delete this.txPromiseCount[txId];
                    }
                })
                    .catch(err => {
                    EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_ERROR, "search", err);
                    this.isSearching = false;
                });
            });
        }
        searchByGeometry(geometry) {
            this.reset();
            this.enableSearchMore = false;
            this.storeManager.configStore.loadSearchConfig().then(searchConfig => {
                this.txId = (0, MathUtil_1.random)();
                let isFirstResult = true;
                let isFirstResultWithData = true;
                (0, EventManager_1.notify)("Searching...");
                EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_INIT, "search");
                this.isSearching = true;
                for (const searchLayer of searchConfig.layers) {
                    const q = new Query_1.default();
                    q.outSpatialReference = this.map.spatialReference;
                    q.returnGeometry = false;
                    q.geometry = geometry;
                    if (geometry instanceof Point_1.default) {
                        q.geometry = new Extent_1.default({
                            xmin: geometry.x - this.SEARCH_PRECISION_DIFF,
                            ymin: geometry.y - this.SEARCH_PRECISION_DIFF,
                            xmax: geometry.x + this.SEARCH_PRECISION_DIFF,
                            ymax: geometry.y + this.SEARCH_PRECISION_DIFF,
                            spatialReference: this.map.spatialReference
                        });
                    }
                    if (geometry instanceof Point_1.default && searchLayer.precision !== -1) {
                        q.geometry = new Extent_1.default({
                            xmin: geometry.x - searchLayer.precision,
                            ymin: geometry.y - searchLayer.precision,
                            xmax: geometry.x + searchLayer.precision,
                            ymax: geometry.y + searchLayer.precision,
                            spatialReference: this.map.spatialReference
                        });
                    }
                    this._search(this.txId, searchLayer, q).then(({ txId, results }) => {
                        if (this.txId === txId) {
                            if (results.length > 0) {
                                for (const g of results) {
                                    g.geometry = geometry;
                                }
                                this.addResult(results, false);
                            }
                            if (isFirstResult) {
                                isFirstResult = false;
                                EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_SUCCESS, "search");
                                (0, RouteStore_1.openRoute)({ pathname: "/search" });
                            }
                            if (isFirstResultWithData && results.length > 0) {
                                isFirstResultWithData = false;
                                const g = results[0];
                                this.map.popup.open(this.getPopupContent(g));
                            }
                            if (this.txPromiseCount[txId] === 0) {
                                this.isSearching = false;
                                delete this.txPromiseCount[txId];
                            }
                        }
                        else {
                            delete this.txPromiseCount[txId];
                        }
                    }).catch(err => {
                        console.error(q.toJSON());
                        EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_ERROR, "search", err);
                        this.isSearching = false;
                    });
                }
            });
        }
        applySymbol(g) {
            if (g.geometry instanceof Point_1.default) {
                if (!!this.lastHighlighted) {
                    this.lastHighlighted.symbol = this.defaultPointSymbol;
                }
                this.lastHighlighted = g;
                g.symbol = this.activePointSymbol;
            }
            else if (g.geometry instanceof Polyline_1.default) {
                if (!!this.lastHighlighted) {
                    this.lastHighlighted.symbol = this.defaultPolylineSymbol;
                }
                this.lastHighlighted = g;
                g.symbol = this.activePolylineSymbol;
            }
            else if (g.geometry instanceof Polygon_1.default) {
                if (!!this.lastHighlighted) {
                    this.lastHighlighted.symbol = this.defaultPolygonSymbol;
                }
                this.lastHighlighted = g;
                g.symbol = this.activePolygonSymbol;
            }
        }
        onResultHighlighted(g) {
            this.applySymbol(g);
            this.map.popup.close();
            this.map.popup.open(this.getPopupContent(g));
        }
        getPopupContent(g) {
            const title = (0, EntityUtil_1.getGraphicAttribute)(g, g.searchLayer.titleField) || "";
            return {
                title,
                content: this.getPopupBody(g),
                location: g.geometry instanceof Point_1.default ? g.geometry : g.geometry.extent.center
            };
        }
        onResultOpen(res) {
            if (res.route) {
                (0, RouteStore_1.openRoute)({ pathname: res.route });
            }
        }
        _search(txId, searchLayer, q) {
            return new Promise((resolve, reject) => {
                this.txPromiseCount[txId] = (this.txPromiseCount[txId] || 0) + 1;
                q.outFields = [];
                if (searchLayer.fields && searchLayer.fields.length > 0) {
                    for (const field of searchLayer.fields) {
                        q.outFields.push(field.name);
                    }
                }
                else {
                    q.outFields.push("*");
                }
                const layer = new FeatureLayer_1.default({ url: searchLayer.url });
                layer.queryFeatures(q).then(featureSet => {
                    const results = [];
                    if (featureSet.features.length > 0) {
                        for (const g of featureSet.features) {
                            g.searchLayer = searchLayer;
                            if (g.searchLayer.route) {
                                const routePath = g.searchLayer.route.replace(/\{\w+\}/g, (all) => {
                                    all = all.replace(/{|}/g, "");
                                    return g.attributes[all] || all;
                                });
                                g.route = routePath;
                            }
                            if (g.geometry) {
                                if (g.geometry instanceof Point_1.default) {
                                    g.symbol = this.defaultPointSymbol;
                                }
                                else if (g.geometry instanceof Polyline_1.default) {
                                    g.symbol = this.defaultPolylineSymbol;
                                }
                                else if (g.geometry instanceof Polygon_1.default) {
                                    g.symbol = this.defaultPolygonSymbol;
                                }
                            }
                            results.push(g);
                        }
                    }
                    this.txPromiseCount[txId]--;
                    resolve({ txId, results });
                }).catch(err => {
                    this.txPromiseCount[txId]--;
                    const ex = new ServiceError_1.ServiceError(err.message);
                    ex.Service = searchLayer.url;
                    ex.StackTrace = err.stack;
                    reject(ex);
                });
            });
        }
    }
    exports.SearchStore = SearchStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchStore.prototype, "results", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchStore.prototype, "resultCount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchStore.prototype, "isSearching", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchStore.prototype, "enableSearchMore", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchStore.prototype, "addResult", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchStore.prototype, "searchByAttribute", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchStore.prototype, "searchByGeometry", null);
});
